import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class DatastoreService {

  constructor(private storage: Storage) {
  }

  set(key: string, data: string) {
    return this.storage.set(key, data);
  }

  get(key: string) {
    return this.storage.get(key);
  }

  keys() {
    return this.storage.keys();
  }

  remove(key: string) {
    return this.storage.remove(key);
  }

  clear() {
    return this.storage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/datastore.service.ts